// extracted by mini-css-extract-plugin
export default {"cartItemContainer":"CartItemList__cartItemContainer___Dj_iJ"};